module.exports = __webpack_public_path__ + "img/zz5.b69a85f7.png";